import { ContentCardProps } from './PublicationsPageContent';

export const text_content =
  'Our team is collaborating with investigative reporters and other media stakeholders who are using our data to examine patterns of excess mortality and under-counting of Covid-19 deaths in specific communities across the United States.';

export const content: ContentCardProps[] = [
  {
    title: 'In Rural America, Covid Hits Black and Hispanic People Hardest.',
    date: 'July 28, 2022',
    text: 'At the peak of the Omicron wave, Covid killed Black Americans in rural areas at a rate roughly 34 percent higher than it did white people. The coronavirus pandemic walloped rural America last year, precipitating a surge of deaths among white residents as the virus inflamed longstanding health deficits there.',
    link: 'https://www.nytimes.com/2022/07/28/health/covid-deaths-black-hispanic-rural.html',
    imgSrc:
      'https://static01.nyt.com/newsgraphics/2022/05/10/omicron-elderly/719365138e6965811e1f8a42217fc762f6fb68af/omicron-per-100k-Artboard_1.png',
    author: 'The New York Times',
  },
  {
    title: 'During the Omicron Wave, Death Rates Soared for older people.',
    date: 'May 31, 2022',
    text: 'Last year, people 65 and older died from Covid at lower rates than in previous waves. But with Omicron and waning immunity, death rates rose again.',
    link: 'https://www.nytimes.com/2022/05/31/health/omicron-deaths-age-65-elderly.html',
    imgSrc:
      'https://static01.nyt.com/newsgraphics/2022/05/10/omicron-elderly/719365138e6965811e1f8a42217fc762f6fb68af/omicron-per-100k-Artboard_1.png',
    author: 'The New York Times',
  },
  {
    title: 'Death certificates reveal that US hit grim COVID milestone.',
    date: 'May 16, 2022',
    text: 'When the U.S. hit 1 million COVID-19 deaths on Monday, the news was driven by a government tally derived from death certificates.',
    link: 'https://apnews.com/article/covid-science-health-pandemics-centers-for-disease-control-and-prevention-8964acf84814e1d4d6971ce13c4af7ef',
    imgSrc:
      'https://storage.googleapis.com/afs-prod/media/1cf3c2233bc24dd7b2f65ad93f51aea3/600.jpeg',
    author: 'Associated Press',
  },
  {
    title:
      'BU professor: True death toll of COVID-19 pandemic could now be as high as 1.22 million in United States.',
    date: 'May 5, 2022',
    text: 'A Boston University professor estimated Thursday that the death toll from the COVID-19 pandemic in the United States could now be as high as 1.22 million, substantially higher than the nearly 1 million that official counts are approaching.',
    link: 'https://www.bostonglobe.com/2022/05/05/nation/bu-professor-true-death-toll-covid-19-pandemic-could-now-be-high-122-million-united-states/',
    imgSrc:
      'https://bostonglobe-prod.cdn.arcpublishing.com/resizer/MwY7NF-RJ0sWn74x94XITsibAMc=/1440x0/cloudfront-us-east-1.images.arcpublishing.com/bostonglobe/BTMX75IXHSNFO66UR6VFEJZ6QY.jpg',
    author: 'Boston Globe',
  },
  {
    title: "What One Million COVID Dead mean for the U.S.'s Future",
    date: 'March 29, 2022',
    text: 'The country has reached an unthinkably grim milestone. Nearly 200,000 children have lost parents, many more elderly have been killed, and family well-being has been ripped apart',
    link: 'https://www.scientificamerican.com/article/what-one-million-covid-dead-mean-for-the-u-s-s-future/',
    imgSrc:
      'https://static.scientificamerican.com/sciam/cache/file/76A6F13E-B613-42DE-9C033AEF7DC68791_source.jpg?w=590&h=800&F2561F8C-A13A-4BF7-8555DC14ED8B3566',
    author: 'Scientific American',
  },
  {
    title: 'How did this many deaths become normal?',
    date: 'March 8, 2022',
    text: 'The United States reported more deaths from COVID-19 last Friday than deaths from Hurricane Katrina, more on any two recent weekdays than deaths during the 9/11 terrorist attacks, more last month than deaths from flu in a bad season, and more in two years than deaths from HIV during the four decades of the AIDS epidemic.',
    link: 'https://www.theatlantic.com/health/archive/2022/03/covid-us-death-rate/626972/',
    imgSrc:
      'https://cdn.theatlantic.com/thumbor/Dkcus6oxI-J4SXxkVqOMU4mLbjc=/0x0:2500x1406/2048x1152/media/img/2022/03/07/GettyImages_1230421868/original.jpg',
    author: 'The Atlantic',
  },
  {
    title: "Uncovering COVID-19's Hidden Deaths in the United States",
    date: 'January 14, 2022',
    text: "As the nation's pandemic death toll approaches one million, a BU public health researcher joins with reporters to investigate why some counties are underreporting deaths",
    link: 'https://www.bu.edu/articles/2022/underreporting-covid-19-deaths/',
    imgSrc: 'https://www.bu.edu/files/2022/01/ft-AP_21260842552386.jpg',
    author: 'The Brink',
  },
  {
    title:
      'Uncounted: Inaccurate death certificates across the country hide the true toll of COVID-19',
    date: 'December 26, 2021',
    text: 'In some counties, half of the spike in deaths during the pandemic is attributed to COVID-19. Researchers say that points to a massive undercount.',
    link: 'https://www.usatoday.com/in-depth/news/nation/2021/12/22/covid-deaths-obscured-inaccurate-death-certificates/8899157002/',
    imgSrc:
      'https://www.gannett-cdn.com/presto/2021/01/24/PLAL/6fb5f7ed-6731-4b18-93ff-fa758081044a-St.Barnabas.Covid.Memorial-24-9.jpg?crop=1332,749,x1,y103?width=1200',
    author: 'USA Today',
  },
  {
    title:
      'Uncounted: Inaccurate death certificates across the country hide the true toll of COVID-19',
    date: 'December 22, 2021',
    text: "Some counties, like Cape Girardeau, have seen a spike in deaths that aren't attributed to COVID-19. Many of them, blamed on natural causes, are likely from the coronavirus",
    link: 'https://missouriindependent.com/2021/12/22/uncounted-inaccurate-death-certificates-across-the-country-hide-the-true-toll-of-covid-19/',
    imgSrc: 'http://missouriindependent.com/wp-content/uploads/2021/12/Cape-Girardeu--1024x685.jpg',
    author: 'Missouri Independent',
  },
  {
    title:
      'The US is undercounting COVID deaths, researchers say. Now they have a tool to figure out why.',
    date: 'December 9, 2021',
    text: "COVID deaths in the United States have been undercounted, public health experts say. They're trying to figure out where and why.",
    link: 'https://www.usatoday.com/story/news/nation/2021/12/09/covid-death-count-america-cdc/6435124001/',
    imgSrc:
      'https://www.gannett-cdn.com/presto/2021/12/09/USAT/7411b682-b008-4bce-bda9-b4742a3611ee-AP_APTOPIX_Virus_Outbreak-Race.jpg?crop=2862,1610,x0,y210&width=2862&height=1610&format=pjpg&auto=webp',
    author: 'USA Today',
  },
  {
    title: "The Pandemic's Hidden Toll Is Revealed in Excess Death Counts",
    date: 'September 1, 2021',
    text: 'Many of the unexpected deaths in rural U.S. counties last year were not recorded as caused by COVID',
    link: ' https://www.scientificamerican.com/article/the-pandemics-hidden-toll-is-revealed-in-excess-death-counts/',
    imgSrc:
      'https://static.scientificamerican.com/sciam/cache/file/09AA86DF-8B75-4CF1-8BCEEA774AC1A241.png',
    author: 'Scientific American',
  },
  {
    title:
      'More than 100,000 U.S. COVID-19 Deaths May Be Uncounted, Many of Them of Blacks or Latinos',
    date: 'June 10, 2021',
    text: 'A detailed analysis suggests that COVID deaths and other pandemic-related mortality may have been significantly undercounted in the rural South and West',
    link: 'https://www.scientificamerican.com/article/excess-deaths-reveal-the-pandemics-hidden-toll-in-some-u-s-counties/',
    imgSrc:
      'https://static.scientificamerican.com/sciam/cache/file/841E857B-3A82-4CF2-9217CD3085E205BA.jpg',
    author: 'Scientific American',
  },
  {
    title: "Excess Deaths Reveal the Pandemic's Hidden Toll in Some U.S. Counties",
    date: 'June 2, 2021',
    text: 'A detailed analysis suggests that COVID deaths and other pandemic-related mortality may have been significantly undercounted in the rural South and West',
    link: 'https://www.scientificamerican.com/article/excess-deaths-reveal-the-pandemics-hidden-toll-in-some-u-s-counties/',
    imgSrc:
      'https://static.scientificamerican.com/sciam/cache/file/841E857B-3A82-4CF2-9217CD3085E205BA.jpg',
    author: 'Scientific American',
  },
  {
    title: 'How large was the undercount of COVID-19 deaths across California?',
    date: 'May 31, 2021',
    text: 'In many California counties, there were far more deaths in 2020 than in a usual year. Yet...',
    link: 'https://www.sfchronicle.com/local/article/How-large-was-the-undercount-of-COVID-19-deaths-16210991.php',
    imgSrc: 'https://s.hdnux.com/photos/01/20/24/36/21055360/4/rawImage.jpg',
    author: 'San Francisco Chronicle',
  },
  {
    title:
      'COVID-19 has been more deadly in Florida than reported, especially in rural counties, study shows',
    date: 'March 31, 2021',
    text: "Many COVID deaths went unreported last year in Florida's rural counties, allowing the severity of the pandemic's impact to be understated, according to a nationwide study released this week.",
    link: 'https://www.sun-sentinel.com/coronavirus/fl-ne-covid-deaths-florida-study-ss-prem-20210331-a4rnsenzajdd5nnwzm2fkg5g5y-story.html',
    imgSrc:
      'https://www.sun-sentinel.com/resizer/a3JMk5ULBQnlWPlUq8WjBKNGvUE=/1200x0/top/cloudfront-us-east-1.images.arcpublishing.com/tronc/EC73IE5MZJEMHITH5VJDQMJPSA.jpg',
    author: 'Sun Sentinel',
  },
  {
    title: 'How Flawed Death Investigations Can Leave Texas Covid-19 Deaths Uncounted',
    date: 'March 30, 2021',
    text: 'According to a new study, undercounts of COVID-19 deaths appear worst in rural and suburban areas served by elected justices of the peace.',
    link: 'https://www.texasobserver.org/how-flawed-death-investigations-can-leave-texas-covid-19-deaths-uncounted/',
    imgSrc:
      'https://www.texasobserver.org/wp-content/uploads/2021/03/AP_20149802823665-759x492.jpg',
    author: 'Texas Observer',
  },
  {
    title: 'Is Pro-Trump Bias Leading Some US Counties to Lowball Covid-19 Deaths?',
    date: 'February 21, 2021',
    text: "BU-led study suggests that it's a real possibility",
    link: 'https://www.bu.edu/articles/2021/is-pro-trump-bias-leading-some-us-counties-to-lowball-covid-19-deaths/',
    imgSrc: 'https://www.bu.edu/files/2021/02/social-GettyImages-1230606561.jpg',
    author: 'BU Today',
  },
  {
    title: 'Undercounting of Covid-19 deaths is greatest in pro-Trump areas, analysis shows',
    date: 'Jan 25, 2021',
    text: 'The analysis suggests that political leanings have helped suppress the true scale of Covid-19 deaths. In cases where the deceased didn’t have a Covid-19 test, a coroner or medical examiner has the freedom to interpret symptoms.',
    link: 'https://www.statnews.com/2021/01/25/undercounting-covid-19-deaths-greatest-in-pro-trump-areas-analysis-shows/',
    imgSrc:
      'https://www.statnews.com/wp-content/uploads/2021/01/GettyImages-1230552894-1024x576.jpg',
    author: 'Stat News',
  },
];
